<template>
  <div class="menu_footer">
    <div class="container">
      <div class="row justify-content-between">
        <div class="col-xl-3 col-lg-4 col-md-6 col-12">
          <div class="menu_footer__logo">
            <router-link to="/">
              <img src="../assets/img/logo.png" alt="Comcasa" title="Comcasa">
            </router-link>
          </div>
          <div class="menu_footer__title">
            <h3>
              Localização
            </h3>
          </div>
          <address>
            {{footerData.address}}
          </address>
          <div class="menu_footer__link">
            <a :href="footerData.address_link" class="pop" target="_blank">
              Veja no mapa
            </a>
          </div>
          <div class="menu_footer__title">
            <h3>
              Entre em contato
            </h3>
          </div>
          <div class="menu_footer__contact" v-if="footerData.phone && footerData.phone_formated">
            <a :href="'tel:'+footerData.phone" class="pop">
              <i class="fa fa-phone"></i> {{footerData.phone_formated}}
            </a>
          </div>
          <div class="menu_footer__contact" v-if="footerData.cellphone && footerData.cellphone_formated">
            <a :href="'https://api.whatsapp.com/send?phone=55'+footerData.cellphone" target="_blank" class="pop">
              <i class="fa fa-whatsapp"></i> {{footerData.cellphone_formated}}
            </a>
          </div>
          <div class="menu_footer__email">
            <a :href="'mailto:'+footerData.email" class="pop">
              {{footerData.email}}
            </a>
          </div>
        </div>
        <div class="col-xl-2 col-md-3 col-12">
          <div class="menu_footer__title menu_footer__title--mb">
            <h3>
              A Comcasa
            </h3>
          </div>
          <div class="menu_footer__menus">
            <ul>
              <li>
                <router-link to="/">
                  Página inicial
                </router-link>
              </li>
              <li>
                <router-link to="/sobre">
                  Sobre a Comcasa
                </router-link>
              </li>
              <li>
                <router-link :to="{name: 'Empreendimentos', query: {for_sale: 1}}">
                  Empreendimentos à venda
                </router-link>
              </li>
              <li>
                <router-link :to="{name: 'Empreendimentos', query: {status: 1}}">
                  Empreendimentos entregues
                </router-link>
              </li>
              <li>
                <router-link to="/blog">
                  Blog
                </router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-xl-2 col-md-3 col-12">
          <div class="menu_footer__title menu_footer__title--mb">
            <h3>
              Atendimento
            </h3>
          </div>
          <div class="menu_footer__menus">
            <ul>
              <li>
                <router-link to="/contato">
                  Fale conosco
                </router-link>
              </li>
              <li>
                <a href="https://www.comcasa.com.br/cms" target="_blanck">
                  Portal do cliente
                </a>
              </li>
              <li>
                <a href="https://www.comcasa.com.br/cms" target="_blanck">
                  Painel do corretor
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-2 col-12">
          <div class="menu_footer__title menu_footer__title--mb">
            <h3>
              Siga-nos
            </h3>
          </div>
          <div class="menu_footer__social">
            <ul class="row">
              <li v-for="(item,index) in socialNetworks" v-if="item.type != 'whatsapp' && item.type != 'twitter'" :key="index">
                <a :href="item.link" target="_blank">
                  <i :class="'fa '+item.icon"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      footerData: {}
    }
  },
  computed: {
    ...mapGetters([
      'socialNetworks',
      'companyData'
    ])
  },
  created () {
    this.$store.dispatch('loadSocialNetworks')
    this.$store.dispatch('listCompanyData')
      .then(() => {
        this.footerData = this.companyData
        if (this.footerData.cellphone) {
          let cellphoneP1 = this.footerData.cellphone.slice(0, 2)
          let cellphoneP2 = this.footerData.cellphone.slice(2, 6)
          if (this.footerData.cellphone.length === 11) {
            cellphoneP2 = this.footerData.cellphone.slice(2, 7)
          }
          let cellphoneP3 = this.footerData.cellphone.slice(-4)

          this.footerData.cellphone_formated = cellphoneP1 + '. ' + cellphoneP2 + '.' + cellphoneP3
        }

        if (this.footerData.phone) {
          let phoneP1 = this.footerData.phone.slice(0, 2)
          let phoneP2 = this.footerData.phone.slice(2, 6)
          if (this.footerData.phone.length === 11) {
            phoneP2 = this.footerData.phone.slice(2, 7)
          }
          let phoneP3 = this.footerData.phone.slice(-4)

          this.footerData.phone_formated = phoneP1 + '. ' + phoneP2 + '.' + phoneP3
        }
      })
  }
}
</script>
<style lang="scss" scoped>
@import '../assets/scss/_variables.scss';
@import '../assets/scss/_ui.scss';
.menu_footer {
  background: $primary;
  padding: 80px 0;
  &__logo {
    margin-bottom: 50px;
  }
  &__title {
    margin-bottom: 20px;
    h3 {
      color: white;
      font-size: 24px;
      font-weight: 900;
      text-transform: uppercase;
    }
    &--mb {
      margin-bottom: 100px;
    }
  }
  address {
    color: white;
    font-size: 18px;
    font-style: italic;
    font-weight: 300;
    line-height: 28px;
    margin-bottom: 10px;
    opacity: 0.7;
  }
  &__link {
    margin-top: 10px;
    margin-bottom: 30px;
    a {
      color: white;
      font-size: 15px;
      font-style: italic;
      font-weight: 300;
      opacity: 0.7;
      text-decoration: underline!important;
      transition: all 0.3s;
      &:hover {
        color: $green;
        transition: all 0.3s;
      }
    }
  }
  &__contact {
    margin-bottom: 10px;
    a {
      color: white;
      font-size: 24px;
      font-weight: 900;
      opacity: 0.7;
      transition: all 0.3s;
      &:hover {
        color: $green;
        transition: all 0.3s;
      }
    }
    i {
      font-size: 22px;
      margin-right: 10px;
    }
  }
  &__email {
    margin-top: 20px;
    a {
      color: white;
      font-size: 18px;
      font-style: italic;
      font-weight: 300;
      opacity: 0.7;
      transition: all 0.3s;
      &:hover {
        color: $green;
        transition: all 0.3s;
      }
    }
  }
  &__menus {
    li {
      margin-bottom: 30px;
      a {
        @extend .pop;
        color: white;
        font-size: 18px;
        opacity: 0.7;
        transition: all 0.3s;
        &:hover {
          color: $green;
          transition: all 0.3s;
        }
      }
    }
  }
  &__social {
    padding: 0 15px;
    a{
      margin: 0 10px;
      i{
        @extend .pop;
        color: white;
        font-size: 22px;
        transition: all 0.3s;
      }
      &:hover {
        i{
          color: $green;
          transition: all 0.3s;
        }
      }
    }
  }
  @media (max-width: 1200px) {
    &__social {
      a{
        margin: 0 5px;
      }
    }
  }
  @media (max-width: 991px) {
    padding: 60px 0;
    &__title {
      h3 {
        font-size: 22px;
      }
      &--mb {
        margin-bottom: 40px;
      }
    }
    &__email {
      margin-bottom: 20px;
    }
    &__logo {
      margin-bottom: 20px;
    }
    &__link {
      margin-bottom: 20px;
    }
    &__menus {
      li {
        margin-bottom: 20px;
      }
    }
  }
  @media (max-width: 767px) {
    padding: 40px 0;
    &__title {
      margin-bottom: 10px;
      &--mb {
        margin-bottom: 10px;
      }
    }
    &__email {
      a {
        font-size: 16px;
      }
    }
  }
  @media (max-width: 575px) {
    padding: 40px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MenuFooter.vue